<app-loading-news *ngIf='isLoading'></app-loading-news>
<div style="text-align: center;" *ngIf='registrantListError && !isLoading'>
  <div class='card'>
    <div class='card-body'>
      <img [src]="'assets/img/noresfound.gif'" height="80" class="mb-2" alt="" loading="lazy">
      <h5>Not Allowed To View Registrants List</h5>
    </div>
  </div>
</div>
<table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-bordered table-striped dataTable dtr-inline">
  <thead>
  <tr>
    <th>Code</th>
    <th>Reg. Timestamp</th>
    <th>Reg. Method</th>
    <th>Name</th>
    <th>Age</th>
    <th>Phone</th>
    <th>BEC</th>
    <th>Remarks</th>
    <th>Zone & Seat</th>
    <th>Actions</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let registrant of registrantList; let i = index">
    <td>{{ registrant.reg_code }}</td>
    <td>{{ registrant.reg_datetime | dateTimeFormatFilter: 'DD MMM YYYY hh:mm A'  }}</td>
    <td>{{ registerMethodConverter(registrant.reg_method) }}</td>
    <td>{{ registrant.reg_name }}</td>
    <td>{{ registrant.reg_birthdate | age}}</td>
    <td>{{ registrant.reg_phone }}</td>
    <td>{{ registrant.reg_bec }}</td>
    <td>{{ registrant.reg_remarks | shorten: 10 }}</td>
    <td>{{ registrant.reg_zone }} {{ registrant.reg_checkinseat }}</td>
    <td><button class='btn btn-primary mr-2 mb-1' [routerLink]="[i]">View</button>
      <button class='btn btn-danger' (click)='onCancelRegistrant(registrant.reg_id)' [disabled]='registrant.reg_checkindatetime !== "-"'>
        <i class="fas fa-trash-alt"></i></button></td>
  </tr>
  </tbody>
</table>
